// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-head {
  display: flex;
  flex-direction: row;
  border-top: 1px solid #bdbdbd;
}
.table-head .results-with-tooltip {
  display: flex;
  column-gap: 0.5rem;
  align-items: center;
  margin-top: 10px;
}
.table-head .compact-view-toggle {
  display: flex;
  margin-top: 10px;
  align-items: center;
  margin-left: auto;
}`, "",{"version":3,"sources":["webpack://./src/kit/components/Navigations/PaginationResultsBlock/index.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;AADF;AAGE;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AADJ;AAIE;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AAFJ","sourcesContent":["@use '@App/assets/styles/variables';\n\n.table-head {\n  display: flex;\n  flex-direction: row;\n  border-top: 1px solid variables.$grayColor4;\n\n  .results-with-tooltip {\n    display: flex;\n    column-gap: 0.5rem;\n    align-items: center;\n    margin-top: 10px;\n  }\n\n  .compact-view-toggle {\n    display: flex;\n    margin-top: 10px;\n    align-items: center;\n    margin-left: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
